<template>
	<div id="ScannedPage">
		<div class="loader-line" v-if="!isCompleted"></div>
		<lottie-animation
			ref="splash_screen"
			:speed="0"
			class="splash_screen"
			:animationData="require('@/assets/animation/splash.json')"
			:autoPlay="true"
			@complete="complete"
			v-if="!isCompleted"
		/>
		<!-- <div class="ad-banner" v-if="showAdBanner" @click="toggleViewType(false)">
      Press here to get your BarkBadge
    </div> -->

		<div v-if="loading" class="loading-spinner">
			<lottie-animation
				ref="splash_screen"
				:speed="0"
				class="splash_screen"
				:animationData="require('@/assets/animation/splash.json')"
				:autoPlay="true"
				@complete="complete"
				v-if="!isCompleted"
			/>
		</div>

		<div v-else-if="!petExist && !loading && feedback">
			{{ feedback }}
		</div>
		<div v-else class="pet-profile">
			<svg
				class="pet-top-menu"
				@click="toggleMenu()"
				width="24"
				height="23"
				viewBox="0 0 24 23"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M5.29167 9.58331C4.2375 9.58331 3.375 10.4458 3.375 11.5C3.375 12.5541 4.2375 13.4166 5.29167 13.4166C6.34583 13.4166 7.20833 12.5541 7.20833 11.5C7.20833 10.4458 6.34583 9.58331 5.29167 9.58331Z"
					stroke="currentColor"
					stroke-width="1.5"
				/>
				<path
					d="M18.7083 9.58331C17.6541 9.58331 16.7916 10.4458 16.7916 11.5C16.7916 12.5541 17.6541 13.4166 18.7083 13.4166C19.7625 13.4166 20.625 12.5541 20.625 11.5C20.625 10.4458 19.7625 9.58331 18.7083 9.58331Z"
					stroke="currentColor"
					stroke-width="1.5"
				/>
				<path
					d="M12 9.58331C10.9459 9.58331 10.0834 10.4458 10.0834 11.5C10.0834 12.5541 10.9459 13.4166 12 13.4166C13.0542 13.4166 13.9167 12.5541 13.9167 11.5C13.9167 10.4458 13.0542 9.58331 12 9.58331Z"
					stroke="#F5C042"
					stroke-width="1.5"
				/>
			</svg>

			<div
				v-if="showMenu"
				class="menu_backdrop"
				@click.prevent="toggleMenu()"
			></div>

			<XyzTransition xyz="fade down">
				<div v-if="showMenu" class="bottom_menu">
					<svg
						width="100%"
						viewBox="0 0 375 162"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M0 40C0 17.9086 17.9086 0 40 0L141.939 0C150.324 0 158.39 3.22032 164.469 8.99592V8.99592C177.095 20.9905 196.905 20.9905 209.531 8.99591V8.99591C215.61 3.22032 223.676 0 232.061 0L335 0C357.091 0 375 17.9086 375 40L375 456L0 456L0 40Z"
							fill="white"
						/>
						<path
							d="M181.462 7.69231C177.426 6.01066 178.628 0 183 0L191 0C195.372 0 196.574 6.01066 192.538 7.69231L188.538 9.35897C187.554 9.76923 186.446 9.76923 185.462 9.35897L181.462 7.69231Z"
							fill="#F5C042"
						/>
					</svg>
					<div class="bottom_menu_content">
						<h2>Menu</h2>
						<p>Purchase your own HeyBuddy or share this profile!</p>
						<div class="btn-group">
							<a href="https://heybuddy.club" class="btn-primary">
								<h2>
									Shop Now
								</h2>
							</a>

							<a @click="openShare()" class="btn-secondary">
								<h2>
									Share
								</h2>
							</a>
						</div>

						<p class="version-number">{{ version_number }}</p>
					</div>
				</div>
			</XyzTransition>

			<div class="pet-top">
				<ProfileBannerSelection
					:pet_banner="pet_data.banner"
					:pet_id="pet_id"
					:editablePage="false"
					:tag_links="pet_data.tag_links"
				/>
				<PetCardSection
					:pet_id="pet_id"
					@toggleAllergyModal="toggleAllergyModal"
					:userdata="ownerdata"
					:editablePage="false"
				/>

				<div class="profile-subnav">
					<button @click="setTab(0)">
						<span :class="current_tab == 0 && 'selected-tab1'">
							Contact
						</span>
					</button>

					<button @click="setTab(1)">
						<span :class="current_tab == 1 && 'selected-tab2'">
							Gallery
						</span>
					</button>

					<div
						:class="{
							'tab-absolute': true,
							'left-0': current_tab == 0,
							'left-50': current_tab == 1,
						}"
					></div>
				</div>
			</div>
			<div class="view-area">
				<ScannedContact
					v-if="current_tab == 0"
					:pet_data="pet_data"
					:ownerdata="ownerdata"
					:owner_address="ownerdata.location.address"
					:otherID="ownerdata.id"
					@alertOwner="alertOwner"
				/>
				<ScannedGallery
					v-if="current_tab == 1"
					ownerdata="ownerdata"
					:pet_data="pet_data"
					:petID="pet_id"
				/>
				<ScannedNotes
					v-if="current_tab == 2"
					:pet_notes="pet_data.notes"
					:pet_data="pet_data"
				/>
			</div>
		</div>
		<AllergyModal
			:pet_data="pet_data"
			:editablePage="false"
			v-if="showAllergyModal"
			@hideModal="toggleAllergyModal"
		/>
	</div>
</template>

<script>
import { fb } from "@/_firebase/init"
import { mapState, mapMutations } from "vuex"
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

import axios from "axios"
// import SkeletonPetCards from "@/petprofile/components/main/SkeletonPetCards.vue"
// import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import ScannedNotes from "@/petprofile/components/scanned/tabs/ScannedNotes.vue"
import ScannedGallery from "@/petprofile/components/scanned/tabs/ScannedGallery.vue"
import ScannedContact from "@/petprofile/components/scanned/tabs/ScannedContact.vue"
import AllergyModal from "@/petprofile/components/main/modals/AllergyModal.vue"
import PetCardSection from "@/petprofile/components/pet/PetCardSection.vue"
import ProfileBannerSelection from "@/petprofile/components/main/ProfileBannerSelection.vue"
import LottieAnimation from "lottie-web-vue"

export default {
	name: "ScannedPage",
	components: {
		// 'vue-spinner': FadeLoader,
		// SkeletonPetCards,
		PetCardSection,
		ScannedGallery,
		ScannedContact,
		AllergyModal,
		ScannedNotes,
		ProfileBannerSelection,
		LottieAnimation,
	},

	data() {
		return {
			current_tab: 0,
			enlarge_image: "",
			showConfirmModal: false,
			showContactModal: false,
			showAdBanner: true,
			isScanning: false,
			showAllergyModal: false,
			petExist: false,
			pets_owned: [],
			showMenu: false,
			ownerdata: {
				id: "",
				username: this.$route.params.username,
				fname: "",
				lname: "",
				phone: "",
				address: {},
				settings: {
					showContactInfo: false,
				},
			},
			pet_id: this.$route.params.pet_id,
			pet_data: { photo: "", name: "" },
			loading: true,
			sliderStyle: {
				left: "0",
			},
			isCompleted: false
		}
	},
	watch: {
		// pets_owned(nv,ov){
		//   console.log(nv, ov)
		//   for(let pid of nv){
		//     this.getPetData(pid)
		//   }
		// }
	},
	mounted() {
		if (
			window.location.href.includes("bark-demo.web.app") ||
			window.location.href.includes("barkbadge.web.app")
		) {
			window.open(
				`https://app.heybuddy.club/u/${this.ownerdata.username}/pet/${this.pet_id}`
			)
		}
		this.$refs.splash_screen.play()
        this.createDeviceID()
	},
	methods: {
		...mapMutations(["SET_PETDATA", "SET_CURRENT_LOCATION"]),
		// toggleViewType(bool){
		//   this.showAdBanner = bool
		//   window.open('https://barkbadge.com?ref=app_banner', '_blank')
		// },
        createDeviceID(){
            let deviceUUID = uuidv4(); // generates a UUID
            Cookies.set('deviceUUID', deviceUUID, { secure: true, 'SameSite': 'Strict' });
        },
		openShare() {
			const link = `https://app.heybuddy.club/u/${this.ownerdata.username}/pet/${this.pet_id}`
			navigator.clipboard.writeText(link)
			if (navigator.canShare) {
				navigator.share({
					url: link,
					title: "HeyBuddy",
					text: ``,
				})
			}
		},
		alertOwner() {
			this.getLocation()
			// this.showLocation()
		},
		complete() {
			this.isCompleted = true
		},
		getLocation() {
			if (!("geolocation" in navigator)) {
				this.errorStr = "Geolocation is not available."
				return
			}
			this.gettingLocation = true
			console.log("getting location")
			navigator.geolocation.getCurrentPosition(
				pos => {
					console.log(pos)
					let lat = pos.coords.latitude
					let long = pos.coords.longitude
					// alert(lat + ":" + long)
					this.SET_CURRENT_LOCATION({ lat, long })

				},
				err => {
					console.log(err)
				},
				{ timeout: 10000 }
			)
		},

		showLocation(position) {
			console.log(
				`Latitude: ${position.coords.latitude}, longitude: ${position.coords.longitude}`
			)
		},
		errorLocation(err) {
			console.log(err)
			alert(err.message)
		},
		setTab(num) {
			this.current_tab = num
			const base_left = 50
			this.sliderStyle.left = `${base_left * num}%`
		},
		async onInit(promise) {
			try {
				await promise
			} catch (error) {
				if (error.name === "NotAllowedError") {
					this.error =
						"ERROR: you need to grant camera access permisson"
				} else if (error.name === "NotFoundError") {
					this.error = "ERROR: no camera on this device"
				} else if (error.name === "NotSupportedError") {
					this.error =
						"ERROR: secure context required (HTTPS, localhost)"
				} else if (error.name === "NotReadableError") {
					this.error = "ERROR: is the camera already in use?"
				} else if (error.name === "OverconstrainedError") {
					this.error = "ERROR: installed cameras are not suitable"
				} else if (error.name === "StreamApiNotSupportedError") {
					this.error =
						"ERROR: Stream API is not supported in this browser"
				}
			}
		},
		toggleAllergyModal() {
			this.showAllergyModal = !this.showAllergyModal
		},
		toggleModal(val) {
			this.showConfirmModal = val
		},
		selectProfileFile(evt) {
			let file = evt.target.files[0]
			var storeRef = fb
				.storage()
				.ref("/pet_profile_media/photo/" + file.name)
			let uploadTask = storeRef.put(file)
			uploadTask.on(
				"state_changed",
				() => {},
				err => {
					console.log(err)
				},
				() => {
					uploadTask.snapshot.ref
						.getDownloadURL()
						.then(downloadURL => {
							this.pet.photo = downloadURL
							// this.updateDataPhoto(downloadURL)
						})
				}
			)
		},
		toggleMenu() {
			this.showMenu = !this.showMenu
		},
		async getPetData() {
			console.log('getting pets')
			try {
				this.loading = true
				console.log("this.pet_id", this.$route.params)
				const response = await axios.get(`${this.$api_path}/pets/${this.pet_id}/guest`)
				console.log("gotscanned", response.data)
				this.loading = false
				console.log('get pet on scanned page', response.data)
				if (response.data.status === "success") {
					this.pet_data = response.data.result.pet
					this.SET_PETDATA(this.pet_data)
					this.ownerdata = response.data.result.user
					this.petExist = true
					return this.pet_data
				} else {
					this.petExist = false
					this.feedback = response.data.feedback
				}
			} catch (e) {
				this.loading = false
			}
			this.loading = true
			// const petRef = db.collection("pets").doc(this.pet_id);
		},
	},
	computed: {
		...mapState(["userID", "ownerID", "version_number"]),
	},
	created() {
		if (this.userID == this.ownerID && this.userID) {
			console.log(this.userID)
			this.$router.push({
				name: "PetPage",
				params: { pet_id: this.pet_id },
			})
		}
		localStorage.removeItem("pet_page")
		this.getPetData()
	},
}
</script>
<style scoped>
#ScannedPage {
	margin: auto;
	max-width: 900px;
	/* min-width: 450px; */
	position: relative;
	/*padding-bottom: 10rem; */
	min-height: 95vh;
	overflow-y: scroll;
	background-color: #fff;
}
/* .ad-banner{
  width: 100%;
  background-color: var(--secondary);
  cursor:pointer;
  font-size: 1.3rem;
  padding: .6rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  text-align: center;
  display: flex;
  justify-content:center;
  align-items:center;
} */
.pet-top {
	background-color: #fff;
}
.splash_screen {
	position: fixed;
	left: 50%;
	transform: translateX(-50%);
	z-index: 109;
	height: 110vh;
	width: 900px;
	background-color: #7523F2;
	background-size: cover;
	background-position: center;
}
.version-number {
	color: #dfdfdf !important;
	text-align: center;
	margin: 0 auto;
	margin-top: 0.3rem;
}
.pet-top-menu {
	position: absolute;
	z-index: 99;
	width: 32px;
	height: 32px;
	left: 6.8%;
	top: 60px;
	padding: 2px;
	color: #6266f9;
	background: #f7f7fb;
	cursor: pointer;
	border-radius: 18px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}
.pet-top-menu:active {
	background: #6266f9;
	color: white;
}
.profile-subnav {
	position: relative;
	width: 86.4%;
	margin: 0 auto;
	margin-bottom: 1rem;
	text-align: center;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	background: #fff;
	background: #f7f7fb;
	border-radius: 12px;
	font-size: 20px;
	padding: 4px;
	text-align: center;
}
.divider {
	width: 3px;
	height: 30px;
	background: #ccc;
}
#slider {
	background-color: var(--primary);
	position: absolute;
	height: 5px;
	width: 50%;
	bottom: 0;
	left: 0;
	transition: 0.5s;
}
.loader-line {
	height: 5px;
	position: fixed;
	top: 5%;
	z-index: 999;
	width: 100%;
	max-width: 900px;
	margin: 0 auto;
	overflow: hidden;
	background-color: rgba(253, 253, 253, 0.5);
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	border-radius: 20px;
}
.loader-line:before {
	content: "";
	height: 5px;
	position: absolute;
	left: -50%;
	width: 40%;
	background-color: rgba(253, 253, 253, 1);
	-webkit-animation: lineAnim 1s linear infinite;
	-moz-animation: lineAnim 1s linear infinite;
	animation: lineAnim 1s linear infinite;
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	border-radius: 20px;
}
@keyframes lineAnim {
	0% {
		left: -40%;
	}
	50% {
		left: 20%;
		width: 80%;
	}
	100% {
		left: 100%;
		width: 100%;
	}
}

.profile-subnav button {
	list-style-type: none;
	width: 100%;
	outline: none;
	background-color: transparent;
	border: none;
	display: block;
	text-align: center;
	overflow: hidden;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	cursor: pointer;
	margin: 0px 2px;
	height: 100%;
	font-weight: 700;
	font-size: 14px;
	color: #64748b;
	line-height: 140%;
	position: relative;
	/* identical to box height, or 20px */
	letter-spacing: 0.2px;
}
.profile-subnav button span {
	padding: 10px;
	z-index: 9;
}
.left-0 {
	left: 6px !important;
}
.left-50 {
	left: calc(50% + 6px) !important;
}
.profile-subnav button img {
	width: 2.2rem;
	height: 2rem;
}
.profile-subnav button:hover {
	/* background-color: #bdcdf4  !important; */
	color: var(--primary);
}
.view-area {
	/* position: relative; */
	padding-bottom: 10rem;
	width: 100%;
	margin: 0;
	background: #f5f6ff;
}
.note-card {
	justify-content: stretch;
	align-items: center;
}
.note-card .dog-img {
	margin: auto;
}
.profile-subnav .selected-tab1,
.profile-subnav .selected-tab2,
.profile-subnav .selected-tab3 {
	/* border-bottom: 4px solid  var(--primary); */
	color: var(--primary);
}

.tab-absolute {
	color: var(--primary);
	background: #ffffff;
	height: calc(100% - 8px);
	box-shadow: 0px 0px 1px rgb(113 128 150 / 4%),
		0px 4px 8px rgb(113 128 150 / 8%);
	border-radius: 8px;
	transition: 0.5s ease-in-out;
	position: absolute;
	border-radius: 8px;
	width: calc(50% - 12px);
}
/*mobile base */
.scanning-for-code {
	display: block;
	height: 100vh;
	width: 100vw;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
}
.close-scanner {
	z-index: 11;
	position: absolute;
	top: 2rem;
	right: 2rem;
	color: #fff;
	padding: 0.4rem 1.2rem;
	font-size: 3rem;
	border-radius: 100%;
	background-color: transparent;
	border: 3px solid #fff;
}
.footer {
	width: 100%;
	position: absolute;
	bottom: 1rem;
}

.bottom-btn {
	width: 90%;
	cursor: pointer;
	border-radius: 40px;
	padding: 0.5rem;
	transition: 1s;
	justify-content: center;
	background-color: var(--primary);
	border: none;
	color: #fff;
	font-size: 1rem;
}
.bottom_menu {
	position: fixed;
	bottom: -4px;
	left: 0;
	right: 0;
	z-index: 99;
	width: 100%;
	margin: auto;
	max-width: 900px;
	max-height: 171px;
	background: transparent !important;
}
.z-999 {
	z-index: 999;
}
.bottom_menu_content {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	margin: auto;
	max-width: 900px;
	padding: 2rem;
	height: 100%;
}
.bottom_menu_content a {
	text-decoration: none;
	border-radius: 88px;
	cursor: pointer;
	outline: none;
	border: none;
	width: calc(50% - 5px);
	padding: 12px 0;
}

.btn-primary {
	background: var(--primary);
}
.btn-secondary {
	background: var(--secondary);
}

.bottom_menu_content p {
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	color: #95a0b8;
}
.bottom_menu_content h2 {
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #00133d;
}
.bottom_menu_content a h2 {
	font-weight: 700;
	font-size: 18px;
	line-height: 23px;
	text-align: center;
	color: #ffffff;
}
.bottom_menu_content .btn-group {
	display: flex;
	justify-content: space-between;
	margin-top: 18px;
}
.menu_backdrop {
	z-index: 19;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	right: 0;
	top: 0;
	background: rgba(0, 0, 0, 0.3);
}
body[data-theme="dark"] .profile-subnav .selected-tab1,
body[data-theme="dark"] .profile-subnav .selected-tab2,
body[data-theme="dark"] .profile-subnav .selected-tab3,
body[data-theme="dark"] .profile-subnav button:hover {
	background-color: #333 !important;
	color: #fff;
}

@media only screen and (max-width: 600px) {
	.edit-allergies img {
		width: 1.2rem;
		height: 1.2rem;
		margin-right: 1rem;
		transition: 1s;
	}
	.trait-pod {
		padding: 0.3rem;
		font-size: 0.6rem;
		margin: auto 0.2rem;
	}
	.no-ig {
		font-size: 0.7rem;
		width: 70%;
		margin: auto;
	}
}
</style>
